export class CycleDetector {
  private readonly maxDepth: number;
  private stack: string[] = [];

  constructor(maxDepth = 10) {
    this.maxDepth = maxDepth;
  }

  enter(sourceBlock: string, event: string): boolean {
    const key = `${sourceBlock}:${event}`;

    if (this.stack.includes(key)) {
      if (import.meta.env.DEV) {
        console.warn(
          `[block-events] Cycle detected: ${[...this.stack, key].join(' → ')} (STOPPED)`,
        );
      }
      return false;
    }

    if (this.stack.length >= this.maxDepth) {
      if (import.meta.env.DEV) {
        console.warn(
          `[block-events] Max cascade depth (${this.maxDepth}) reached: ${this.stack.join(' → ')} (STOPPED)`,
        );
      }
      return false;
    }

    this.stack.push(key);
    return true;
  }

  exit(): void {
    this.stack.pop();
  }

  reset(): void {
    this.stack = [];
  }
}
